import Validation, { emailValidation, requiredValidation } from 'vendor/zod/validationZod';
import { object } from 'zod';

export const loginForm = (function () {
    const config = {
        form: '.login-form'
    };

    const init = () => {
        const schema = object({
            email: requiredValidation.pipe(emailValidation),
            password: requiredValidation
        });

        const loginFormValidation = new Validation({
            form: config.form,
            schema
        });
        loginFormValidation.initValidation();
    };

    return {
        init: init
    };
})();
